"use strict";

import {findIn, findAllIn, addClass, on, hasClass} from "@elements/dom-utils";
import * as scrollSlider from "@elements/scroll-slider"
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    //needed because shown.bs.collapse is fired initially
    on('show.bs.collapse', function (event) {
        console.log("show");
        on('shown.bs.collapse', function (event) {
            console.log("shown"); 
            let accordionSlider = findIn('.js-scroll-slider--accordion', event.target);

            if(accordionSlider && !hasClass('slider--initialized', accordionSlider)) {
                scrollSlider.createScrollSlider(accordionSlider,
                    {
                        arrowIconClass:"icon icon-slide-right"
                    }
                );

                addClass('slider--initialized', accordionSlider);
            }
        }, event.target)
    }, document.body);
}